/** @category Version */

// Note: This file is autogenerated using "resources/gen-version.js" script and
// automatically updated by "npm version" command.

/** A string containing the version of the GraphQL.js library */
export const version = '17.0.2' as string;

/** An object containing the components of the GraphQL.js version string */
export const versionInfo: Readonly<{
  major: number;
  minor: number;
  patch: number;
  preReleaseTag: string | null;
}> = Object.freeze({
  major: 17,
  minor: 0,
  patch: 2,
  preReleaseTag: null,
});
